/* Courted · Ideas: your favourites (anywhere one of you loved), then what you both said yes to by kind
   (Restaurants, Bars, Something fun, Culture, Outdoors), then yours to suggest (your yeses your partner hasn't seen:
   plan one and they're asked), with your partner's yeses waiting for yours on top, and where one of you wouldn't go
   again at the foot. A place is its own page: the photo, what it is, our line, the drive, the booking note, when
   you're next both free, Plan it, its website and Open in Maps, and how it was once you've been. */
import React from 'react';
import * as H from './helpers.js';
import * as S from './sync.js';
import { Ico, Plate, Art, Page, Google, track } from './ui.jsx';

const { useState, useEffect } = React;

function Tile({ id, card, cat, kind, onOpen, load, note }) {
  const name = (cat && cat.name) || (card && card.name) || '';
  return (
    <button type="button" className="co-tile" onClick={() => onOpen(id)}>
      <Plate card={card} kind={kind} load={load} className="ph" />
      <b>{name || '\u00a0'}</b>
      <small>{note || (card ? [H.whatOf(card, cat), card.minutes ? card.minutes + ' min' : null].filter(Boolean).join(' · ') : '\u00a0')}</small>
    </button>
  );
}
const lovedWords = (by, P) => (by === 'both' ? 'You both loved it' : by === 'me' ? 'You loved it' : (P || 'They') + ' loved it');
const neverWords = (by, P) => (by === 'both' ? 'Neither of you would go again' : by === 'me' ? 'You wouldn’t go again' : (P || 'They') + ' wouldn’t go again');

/* `away`: the towns you've looked at besides home (Go out anywhere), each with what you both like there and yours to
   suggest — their own sections, after home's, so a weekend in Paris doesn't fill Tuesday's ideas. */
export function IdeasR({ ideas, waiting, mine = [], favs = [], notAgain = [], away = [], cardsById, catById, partnerName, solo, onOpen, onSwipe }) {
  const [kind, setKind] = useState('all');
  const favIds = new Set(favs.map((f) => f.id));
  const withKind = ideas.filter((i) => !favIds.has(i.id)).map((i) => ({ ...i, kind: H.kindOf(i.id, catById[i.id], cardsById[i.id], i.kind) }));
  const counts = {};
  withKind.forEach((i) => { counts[i.kind] = (counts[i.kind] || 0) + 1; });
  const shown = kind === 'all' ? withKind : withKind.filter((i) => i.kind === kind);
  const yours = mine.filter((i) => !favIds.has(i.id));
  let n = 0;
  const tiles = (list, note) => <div className="co-grid">{list.map((i) => <Tile key={i.id} id={i.id} card={cardsById[i.id]} cat={catById[i.id]} kind={H.kindOf(i.id, catById[i.id], cardsById[i.id], i.kind)} onOpen={onOpen} load={n++ < 12} note={note ? note(i) : null} />)}</div>;
  const favSec = favs.length ? (
    <section className="co-sec">
      <h2 className="co-display co-h2">Your favourites</h2>
      {tiles(favs, (f) => lovedWords(f.by, partnerName))}
    </section>
  ) : null;
  const yoursSec = yours.length ? (
    <section className="co-sec">
      <h2 className="co-display co-h2">Yours to suggest</h2>
      <p className="co-secnote">{partnerName} hasn’t seen {yours.length === 1 ? 'this' : 'these'} yet. Plan one and we’ll ask.</p>
      {tiles(yours)}
    </section>
  ) : null;
  const awaySec = away.filter((a) => a.list.length).map((a) => (
    <section key={a.town.id} className="co-sec">
      <h2 className="co-display co-h2">In {a.town.name}</h2>
      {tiles(a.list, (i) => (i.mine && partnerName ? partnerName + ' hasn’t seen it' : null))}
    </section>
  ));
  const notSec = notAgain.length ? (
    <details className="co-sec co-notagain">
      <summary><span className="co-h2">Not again, for now</span><small>{notAgain.length}</small><Ico n="i-chevron-down" s /></summary>
      {tiles(notAgain, (x) => neverWords(x.by, partnerName))}
    </details>
  ) : null;
  if (!ideas.length) {
    return (
      <div className="co-main">
        {waiting.length ? <Waiting waiting={waiting} cardsById={cardsById} partnerName={partnerName} onSwipe={onSwipe} /> : null}
        {favSec}
        {yoursSec}
        {awaySec}
        {favs.length || yours.length || awaySec.length ? null : <div className="co-empty">
          <h2 className="co-display">{solo ? 'Your yeses go here' : 'Nothing you both like yet'}</h2>
          <p>{solo ? 'Swipe on places near home. When your partner joins, the ones you both like stay here.' : 'Swipe on your own. What you both say yes to lands here, and This week suggests one when you’re both free.'}</p>
          <button type="button" className="dv-btn dv-btn-pop" onClick={onSwipe}>Start swiping</button>
        </div>}
        {notSec}
        <Google />
      </div>
    );
  }
  return (
    <div className="co-main">
      <div className="co-chiprow" role="radiogroup" aria-label="Kinds">
        <button type="button" className="dv-chip" aria-pressed={kind === 'all' ? 'true' : 'false'} onClick={() => setKind('all')}>All {ideas.length}</button>
        {H.KINDS.filter((k) => counts[k.id]).map((k) => (
          <button key={k.id} type="button" className="dv-chip" aria-pressed={kind === k.id ? 'true' : 'false'} onClick={() => { setKind(k.id); track('courted_ideas_kind', { kind: k.id }); }}>{k.label}</button>
        ))}
      </div>
      {waiting.length ? <Waiting waiting={waiting} cardsById={cardsById} partnerName={partnerName} onSwipe={onSwipe} /> : null}
      {kind === 'all' ? favSec : null}
      {H.KINDS.map((k) => {
        const list = shown.filter((i) => i.kind === k.id);
        if (!list.length) return null;
        return (
          <section key={k.id} className="co-sec">
            <h2 className="co-display co-h2">{k.label}</h2>
            {tiles(list)}
          </section>
        );
      })}
      {kind === 'all' ? yoursSec : null}
      {kind === 'all' ? awaySec : null}
      {kind === 'all' ? notSec : null}
      <Google />
    </div>
  );
}

function Waiting({ waiting, cardsById, partnerName, onSwipe }) {
  return (
    <button type="button" className="dv-card co-waiting" onClick={() => { track('courted_waiting_opened', { n: waiting.length }); onSwipe(); }}>
      <span className="thumbs">{waiting.slice(0, 4).map((id) => <span key={id} className="t"><Art id={id} kind={null} type={cardsById[id] && cardsById[id].type} /></span>)}</span>
      <span className="tx"><b>{partnerName} likes {waiting.length} you haven’t seen</b><small>They’re first in your deck</small></span>
      <Ico n="i-chevron" s />
    </button>
  );
}

const hostOf = (u) => { try { return new URL(u).hostname.replace(/^(www|bid)\./, ''); } catch (e) { return null; } };
/* What's been said about a place, as its tag: how it was first, then the yeses. */
export function placeTag(mine, theirs, partnerName, solo) {
  const P = partnerName || 'Your partner';
  if (mine === 'loved' && theirs === 'loved') return { t: 'You both loved it', good: true };
  if (mine === 'never') return { t: 'You wouldn’t go again', good: false };
  if (theirs === 'never') return { t: P + ' wouldn’t go again', good: false };
  if (mine === 'loved') return { t: 'You loved it', good: true };
  if (theirs === 'loved') return { t: P + ' loved it', good: true };
  const yes = H.yesLike(mine), they = H.yesLike(theirs);
  if (yes && (solo || they)) return { t: solo ? 'You said yes' : 'You both said yes', good: true };
  if (they) return { t: P + ' said yes', good: true };
  if (yes) return { t: 'You said yes', good: true, sub: solo || theirs ? null : P + ' hasn’t seen it yet. Plan it and we’ll ask.' };
  if (mine === 'been') return { t: 'You’ve been', good: true };
  return null;
}

/* A place's own page. */
export function PlaceR({ id, card, cat, mine, theirs, partnerName, solo, slot, sunset, wx, words, today, onBack, backLabel, onPlan, onAnswer }) {
  const kind = H.kindOf(id, cat, card);
  const name = (cat && cat.name) || (card && card.name) || '';
  const tag = placeTag(mine, theirs, partnerName, solo);
  // Google's rating and its line about the place (DOM-26), and the website: ours when the catalogue has one, else
  // Google's — all asked only here and for the card on top
  const [site, setSite] = useState((cat && cat.website) || null);
  const [ab, setAb] = useState(() => S.aboutNow(id));
  useEffect(() => {
    if (!card || card.missing) return undefined;
    let off = false;
    S.about(id).then((v) => {
      if (off || !v) return;
      setAb(v);
      if (cat && cat.website) setSite(cat.website);
      else if (v.site !== undefined) setSite(v.site);
      else S.site(id).then((u) => { if (!off) setSite(u); });   // a search brought the rating, not the website
    });
    return () => { off = true; };
  }, [id, cat && cat.website, !!card]);
  const been = mine === 'been' || mine === 'loved' || mine === 'never';
  const rows = [];
  if (card && card.minutes) rows.push(['i-car', card.minutes + ' min by car from home']);
  const outing = H.outingWords(cat, words);
  if (outing) rows.push(['i-walk', outing]);
  if (H.bookingLive(cat, today)) rows.push(['i-info', cat.booking_note + (cat.booking_until ? ', until ' + H.shortDate(cat.booking_until, words && words.country) : ''), cat.booking_url]);
  if (slot && !slot.unknown) rows.push(['i-calendar', H.dayNote(slot, kind, sunset, words, wx)]);
  if (site && hostOf(site)) rows.push(['i-link', hostOf(site), site, 'site']);
  return (
    <Page onBack={onBack} back={backLabel} label={name} className="co-place">
      <div className="co-hero"><Plate card={card} kind={kind} load className="hero" by /></div>
      <div className="co-pbody">
        {tag ? <span className={'dv-tag co-yes' + (tag.good ? '' : ' no')}><Ico n={tag.good ? 'i-heart-f' : 'i-x'} s />{tag.t}</span> : null}
        <h1 className="co-display">{name}</h1>
        {ab && ab.rating ? <p className="co-sub co-prating"><span className="co-rating"><Ico n="i-star-f" s />{ab.rating.toFixed(1)}</span>{ab.count ? ' · ' + ab.count.toLocaleString('en-US') + (ab.count === 1 ? ' review' : ' reviews') + ' on Google' : ' on Google'}</p> : null}
        <p className="co-sub">{[H.whatOf(card, cat, words), card ? H.areaOf(card.address) + (H.townOf(card.address) ? ', ' + H.townOf(card.address) : '') : null].filter(Boolean).join(' · ')}</p>
        {cat && cat.line ? <p className="co-line">{cat.line}</p> : ab && ab.summary ? <p className="co-line">{ab.summary}</p> : null}
        {tag && tag.sub ? <p className="co-pnote">{tag.sub}</p> : null}
      </div>
      {rows.length ? (
        <ul className="co-facts">
          {rows.map(([ic, t, href, what]) => (
            <li key={t}>{href ? <a href={href} target="_blank" rel="noopener noreferrer" onClick={what === 'site' ? () => track('courted_site_opened', { catalogue: !!(cat && cat.website) }) : undefined}><Ico n={ic} s />{t}<Ico n="i-external" s /></a> : <><Ico n={ic} s /><span>{t}</span></>}</li>
          ))}
        </ul>
      ) : null}
      <div className="co-pacts">
        <button type="button" className="dv-btn dv-btn-pop" onClick={onPlan}>Plan it</button>
        {card && card.maps ? <a className="dv-btn dv-btn-plain" href={card.maps} target="_blank" rel="noopener noreferrer" onClick={() => track('courted_maps_opened', {})}><Ico n="i-pin" s />Open in Maps</a> : null}
      </div>
      {!been && mine !== 'yes' ? <div className="co-pacts co-answer"><button type="button" className="dv-btn dv-btn-soft" onClick={() => onAnswer('yes')}>I’d go</button><button type="button" className="dv-quiet" onClick={() => onAnswer('no')}>Not for us</button></div> : null}
      {/* one answer or none: tap the one that's on again and it's just been there */}
      <div className="co-been">
        <p className="co-been-q" id={'co-been-' + id}>{been ? 'How was it?' : 'Been there?'}</p>
        <div className="dv-seg" role="radiogroup" aria-labelledby={'co-been-' + id}>
          <button type="button" role="radio" aria-checked={mine === 'loved' ? 'true' : 'false'} onClick={() => onAnswer(mine === 'loved' ? 'been' : 'loved')}>Loved it</button>
          <button type="button" role="radio" aria-checked={mine === 'never' ? 'true' : 'false'} onClick={() => onAnswer(mine === 'never' ? 'been' : 'never')}>Not again</button>
        </div>
      </div>
      {mine === 'yes' ? <button type="button" className="dv-quiet co-notfor" onClick={() => onAnswer('no')}>Not for us any more</button> : null}
      <Google weather={!!wx} />
    </Page>
  );
}
